const rankingItems = [
  { rank: 1, title: '社内相亲', category: '韩漫·恋爱', tag: '热度飙升', views: '186.5万', chapters: '已完结' },
  { rank: 2, title: '我独自升级', category: '韩漫·奇幻', tag: '长期霸榜', views: '152.3万', chapters: '连载中' },
  { rank: 3, title: '女神降临', category: '韩漫·校园', tag: '新番上榜', views: '128.7万', chapters: '已完结' },
  { rank: 4, title: '间谍过家家', category: '日漫·喜剧', tag: '人气稳定', views: '99.4万', chapters: '连载中' },
  { rank: 5, title: '某天成为公主', category: '韩漫·穿越', tag: '口碑佳作', views: '87.2万', chapters: '已完结' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">热门榜单</h2>
          <p className="text-sm text-foreground-500 mt-2">女神漫画下拉式全网最热作品排名，实时更新</p>
        </div>

        <div className="space-y-3">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors duration-200 cursor-pointer group"
            >
              <div className={`w-10 h-10 flex items-center justify-center rounded-lg font-heading text-lg flex-shrink-0 ${
                item.rank === 1 ? 'bg-accent-500 text-background-50' :
                item.rank === 2 ? 'bg-secondary-400 text-background-50' :
                item.rank === 3 ? 'bg-primary-300 text-background-50' :
                'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors truncate">
                    {item.title}
                  </h3>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 mt-0.5">{item.category}</p>
              </div>
              <div className="hidden sm:flex items-center gap-4 text-xs text-foreground-500 flex-shrink-0">
                <span className="whitespace-nowrap"><i className="ri-eye-line mr-1"></i>{item.views}</span>
                <span className={`whitespace-nowrap px-2 py-0.5 rounded-full text-xs font-medium ${
                  item.chapters === '连载中' ? 'bg-primary-100 text-primary-600' : 'bg-secondary-100 text-secondary-600'
                }`}>
                  {item.chapters}
                </span>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-500 transition-colors hidden sm:block"></i>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}